import React, { useCallback } from 'react';

// COMPONENTS
import Icon from '../Icon/Icon';

// ENUMS
import { Icons } from '../../enums/icons';
import { Alignments } from '../../enums/alignments';

// INTERFACES
import { IPagination } from '../../interfaces/Pagination.interfaces';

// STYLES
import { Button, CurrentPage, Pages, PaginationContainer, TotalPages } from './styles';

const Pagination: React.FC<IPagination> = ({
  aligment = Alignments.RIGHT,
  currentPage,
  loading,
  nextEnable,
  noBorder = false,
  onChange,
  onNext,
  onPrev,
  prevEnable,
  totalPages,
}: IPagination) => {
  const pageNumber = currentPage + 1 || 1;

  const handleNext = useCallback(() => {
    if (nextEnable || !loading) {
      onNext();
    }
  }, [onNext, loading]);

  const handlePrev = useCallback(() => {
    if (prevEnable || !loading) {
      onPrev();
    }
  }, [onPrev, loading]);

  const handleChange = useCallback(
    (e) => {
      onChange(e);
    },
    [onChange, totalPages]
  );

  return (
    <PaginationContainer noBorder={noBorder} aligment={aligment}>
      <Button disabled={!prevEnable || loading} onClick={handlePrev}>
        <Icon type={Icons.ARROW_LEFT} />
      </Button>
      <Pages>
        <TotalPages>{`${pageNumber} de ${totalPages || 1}`}</TotalPages>
      </Pages>
      <Button disabled={!nextEnable || loading} onClick={handleNext}>
        <Icon type={Icons.ARROW_RIGHT} />
      </Button>
    </PaginationContainer>
  );
};

export default Pagination;
